import cookies from "js-cookie";
import { showDialogModal } from "./modal";
import EventBus from "../events/EventBus";
// Поля, в которых пользователь печатает: фокус на чекбоксе или кнопке не мешает показу
var TEXT_FIELD_SELECTOR = 'input:not([type="checkbox"], [type="radio"], [type="button"], [type="submit"], [type="reset"], [type="range"]), textarea, select, [contenteditable]';
/**
 * Промо-окно показывается спустя data-delay мс видимости вкладки после полной
 * загрузки страницы — до тех пор, пока пользователь его не закроет или не перейдёт
 * по ссылке из него. Тогда флаг data-promo-key пишется в localStorage (или в куку, если оно недоступно), поэтому
 * новое промо достаточно завести под новым ключом.
 */
export default function initPromoModal() {
    var content = document.querySelector('.promo-modal[data-promo-key]');
    var modal = content === null || content === void 0 ? void 0 : content.closest('dialog.modal');
    var key = content === null || content === void 0 ? void 0 : content.dataset.promoKey;
    if (!content || !modal || !key || wasDismissed(key)) {
        return;
    }
    var delay = Number(content.dataset.delay) || 0;
    var open = function () {
        // Окно могли закрыть в другой вкладке, пока шёл отсчёт
        if (wasDismissed(key)) {
            return;
        }
        // Пользователь занят — отсчитываем задержку заново, чтобы окно
        // не всплыло в ту же секунду, как он закроет меню или выйдет из поля
        if (isUserBusy()) {
            runWhileVisible(delay, open);
            return;
        }
        showDialogModal(modal);
    };
    var schedule = function () { return runWhileVisible(delay, open); };
    EventBus.on('modal:close', function (closedModal) {
        if (closedModal === modal) {
            markDismissed(key);
        }
    });
    // Переход по ссылке из окна не закрывает его, но показывать промо повторно уже незачем
    content.addEventListener('click', function (event) {
        if (event.target.closest('a[href]')) {
            markDismissed(key);
        }
    });
    if (document.readyState === 'complete') {
        schedule();
    }
    else {
        window.addEventListener('load', schedule, { once: true });
    }
}
// Отсчитывает delay только пока вкладка видима
function runWhileVisible(delay, callback) {
    var remaining = delay;
    var startedAt = 0;
    var timerId;
    var start = function () {
        startedAt = performance.now();
        timerId = window.setTimeout(finish, remaining);
    };
    var pause = function () {
        clearTimeout(timerId);
        remaining -= performance.now() - startedAt;
    };
    var finish = function () {
        document.removeEventListener('visibilitychange', onVisibilityChange);
        callback();
    };
    var onVisibilityChange = function () { return document.hidden ? pause() : start(); };
    document.addEventListener('visibilitychange', onVisibilityChange);
    if (!document.hidden) {
        start();
    }
}
// Открытая модалка, панель мобильного меню или фокус в текстовом поле
function isUserBusy() {
    var _a;
    return Boolean(document.querySelector('dialog[open]'))
        || Boolean((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.matches(TEXT_FIELD_SELECTOR));
}
function wasDismissed(key) {
    try {
        if (localStorage.getItem(key) !== null) {
            return true;
        }
    }
    catch (_a) {
        // Хранилище недоступно — флаг мог быть записан в куку
    }
    return cookies.get(key) !== undefined;
}
function markDismissed(key) {
    try {
        localStorage.setItem(key, '1');
    }
    catch (_a) {
        // Хранилище недоступно (приватный режим, переполнение) — запоминаем в куке
        cookies.set(key, '1', { path: '/', expires: 365 });
    }
}
